<script>
import ChildRepository from '../../js/repository/ChildRepository';
import DataProvider from './DataProvider.vue';

export default {
    components: {
        'kgr-data-provider': DataProvider,
    },
    props: {
        childId: {
            type: Number,
            required: true,
        },
    },
    render(createElement) {
        return createElement(DataProvider, {
            props: {
                repository: ChildRepository.find,
                params: [this.childId],
                disableLoader: true,
            },
            scopedSlots: this.$scopedSlots,
        });
    },
};
</script>
